import React from 'react'

const HighlightText = ({text}) => {
  return (
    <span className='text-richblue'>{text}</span>
  )
}

export default HighlightText
